import { render, staticRenderFns } from "./MotoristaCarroRead.vue?vue&type=template&id=1999468b&"
import script from "./MotoristaCarroRead.vue?vue&type=script&lang=js&"
export * from "./MotoristaCarroRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports